import React from "react"
import * as styles from "./cellular.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';
import PercentageDonut from "./percentageDonut";
import Text from './text'
import {Grid, GridItem} from './grid';

function getPercentage(input) {
    let cleanedString = input.replace(/[^0-9,.]/g, '');
    let formattedString = cleanedString.replace(/,/g, '.');
    return formattedString;
}

export default function Cellular(props) {
    console.log(props);
    return (
        <div className={styles.cellular}>
            <div className={styles.left}>
                <h2 className={styles.headline}>{props.headline}</h2>
                <p>
                    <Text content={props.text} />
                </p>
            </div>
            <div  className={styles.right}>    
                <Grid cols-xs={1} cols-md={2} cols-lg={2} hasGap={false}>
                    <GridItem><PercentageDonut value={getPercentage(props.kpis[0].data)} label={props.kpis[0].label} /></GridItem>
                    <GridItem><PercentageDonut value={getPercentage(props.kpis[1].data)} label={props.kpis[1].label} /></GridItem>
                </Grid>
                <p><Text content={props.remarks} /></p>
            </div>
        </div>
    )
}